import React from "react";
import { Drawer } from "@mui/material";
import GrouMemberList from "./GroupMemberDeatils";
import { leftOverlayDrawerSx } from "../../../assets/commonFunction";
const GroupMemberDrawer = ({ isGroupmembermenu, handleCloseMemberDrawer }) => {
  return (
    <React.Fragment>
      <Drawer
        sx={{ zIndex: 1202, ...leftOverlayDrawerSx }}
        open={isGroupmembermenu}
        anchor={"left"}
        variant="persistent"
      >
        <GrouMemberList handleCloseMemberDrawer={handleCloseMemberDrawer} />
      </Drawer>
    </React.Fragment>
  );
};

export default GroupMemberDrawer;
